import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/artifacts/new")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/artifacts/new", search, replace: true });
    },
});
